import React from 'react';
import { findDOMNode, render, unmountComponentAtNode } from 'react-dom';
import { Menu } from 'antd';
import classnames from 'classnames';
import { Checkbox, Input } from '@platform/base';
import { 
    getGlobalStorage, 
    setGlobalStorage, 
    isNumber, 
    toast,
    getSysFieldid,
} from '@platform/api';
import { setLocalStorageColumnsWidth } from '../../adapter/utils/handleProps';
import { isValidType } from '@platform/template';
import { getLocalStorageKey } from '../../adapter/utils';
import { getRawColumns, setColumns, resetWidths } from './requestUtil';
import ColSettingSide from './ColumnSetting';
import { getScrollBarSize } from '../../utils';

import 'antd/es/menu/style/index.css';
import 'antd/es/tooltip/style/index.css';
import 'antd/es/dropdown/style/index.css';
import 'antd/es/button/style/index.css';
// import 'antd/es/menu/style/css.js';
// import 'antd/es/dropdown/style/css.js';
import './index.less';

const scrollBarSize = getScrollBarSize();

const MENU_COPY = 'MENU_COPY';
const MENU_COPY_ROW = 'MENU_COPY_ROW';
const MENU_COPY_COL = 'MENU_COPY_COL';
const MENU_ADD_ROW_UP = 'MENU_ADD_ROW_UP';
const MENU_ADD_ROW_DOWN = 'MENU_ADD_ROW_DOWN';
const MENU_DEL_ROW = 'MENU_DEL_ROW';
const MENU_AUTO_WRAP = 'MENU_AUTO_WRAP';
const MENU_SAVE_COL_WIDTH = 'MENU_SAVE_COL_WIDTH';
const MENU_RESET = 'MENU_RESET';
const MENU_COL_SETTING = 'MENU_COL_SETTING';

const { Item, SubMenu, Divider } = Menu;

const showSuccessToast = msg => toast({ content: msg, light: true });

function useContextMenu(Table){
    return class MenuTable extends React.Component {

        state = {
            rowInfo: {},
            colInfo: {},
            addUpNum: 0,
            addDownNum: 0,
            showColSetting: false,
            hasScrollBar: false, 
        }

        componentDidMount() {
            document.addEventListener('click', this.handleOutsideClick);            
        }

        render(){
            let { columns = [], contextMenuConfig = {}, store, id, flex, locale, _onScrollBarStatusChange } = this.props;
            let { showColSetting, hasScrollBar } = this.state;
            const { 
                enable,
                disableArea,
                hiddenLeftItem,
                cancelCustomRightMenu = true,
            } = contextMenuConfig;

            if(!enable){
                return <Table {...this.props} />;
            }

            return <>
                <div
                    className={classnames('context-menu-container', { 'flex-container': flex })}
                    onContextMenu={this.handleContextMenuShow}
                >
                    <Table 
                        {...this.props}
                        columns={columns}
                        cellProps={(rowInfo, colInfo) => {
                            let otherProps = this.props.cellProps?.(rowInfo, colInfo) || {};
                            return {
                                ...otherProps,
                                onContextMenu: e => {
                                    let disabled = disableArea?.(rowInfo?.row?.key, colInfo?.col?.key);

                                    if(disabled){
                                        e.stopPropagation();
                                    } else {
                                        this.setState({ rowInfo, colInfo });
                                    }

                                    otherProps?.onContextMenu?.(e);
                                },
                            };
                        }}
                        _onScrollBarStatusChange={status => {
                            // 滚动条状态变化触发（是否有滚动条）
                            this.setState({ hasScrollBar: status });
                            _onScrollBarStatusChange?.(status);
                        }}
                    />
                    {!cancelCustomRightMenu && <i 
                        className="header-icon col-setting-icon"
                        style={{ marginRight: hasScrollBar ? scrollBarSize : 0 }}
                    >
                        <i className='iconfont icon-lbsz' onClick={this.showColSettingSide} />
                    </i>}
                </div>
                <ColSettingSide 
                    show={showColSetting}
                    onClose={this.hideColSettingSide}
                    store={store}
                    id={id}
                    hiddenLeftItem={hiddenLeftItem}
                    tableBody={findDOMNode(this)}
                    wrapStatus={getAutoWrap(store, id)}
                    onWrapChange={this.handleWrapChange}
                    locale={locale}
                />
            </>;
        }

        componentWillUnmount() {
            this.handleContextMenuClose();
            document.removeEventListener('click', this.handleOutsideClick);   
        }

        handleContextMenuShow = event => {
            this.handleContextMenuClose();

            if (!event.currentTarget.contains(event.target)) {
                return;
            }

            event.preventDefault();

            let { contextMenuConfig = {}, store, id, locale } = this.props;
            let { rowInfo, colInfo, addUpNum, addDownNum } = this.state;
            const { 
                extendRightMenu, 
                extendRightMenuPlacement = 'bottom', 
                rightMenuClick,
                cancelCustomRightMenu = true,
                onVisibleChange,
                disabled = new Set(),
                showWidthAndHeightConfig = true,
                columnWidthConfig,
            } = contextMenuConfig;

            let showRowMenu = store.getStatus() === 'edit' && typeof rightMenuClick === 'function';

            let div = document.createElement('div');
            div.style.position = 'fixed';
            div.style.zIndex = '1050';

            document.body.appendChild(div);

            this.contextMenuContainer = div;

            render(<div 
                className='context-menu-dropdown'
                onMouseDown={event => {
                    event.stopPropagation();
                }}
            >
                <Menu 
                    fieldid={getSysFieldid("column-right")}
                    mode="vertical"
                    onClick={this.handleMenuClick}
                    subMenuCloseDelay={0.5}
                >
                    {extendRightMenuPlacement === 'top' && <div onClick={this.handleMenuClick}>{extendRightMenu?.({
                        rowIndex: rowInfo.dataIndex, 
                        attrcode: colInfo?.col?.key, 
                        column: colInfo?.col,
                        record: rowInfo?.row,
                    }) || ''}</div>}
                    <Item key={MENU_COPY}>{locale['table_copy'] /*复制*/}</Item>
                    <Item key={MENU_COPY_ROW}>{locale['table_copy-row'] /*复制行信息*/}</Item>
                    <Item key={MENU_COPY_COL}>{locale['table_copy-column'] /*复制列信息*/}</Item>
                    {(showRowMenu || showWidthAndHeightConfig || !cancelCustomRightMenu) && <Divider/>}
                    {showRowMenu && <>
                        <Item key={MENU_ADD_ROW_UP}>
                            {locale['table_insert_up'] /*向上增行*/}
                            <Input
                                onChange={value => {
                                    if(!isNumber(+value)) return;
                                    this.setState({ addUpNum: +value });
                                }}
                                value={addUpNum || ''}
                                onClick={e => e.stopPropagation()}
                            />
                        </Item>
                        <Item key={MENU_ADD_ROW_DOWN}>
                            {locale['table_insert_down'] /*向下增行*/}
                            <Input
                                onChange={value => {
                                    if(!isNumber(+value)) return;
                                    this.setState({ addDownNum: +value });
                                }}
                                value={addDownNum || ''}
                                onClick={e => e.stopPropagation()}
                            />
                        </Item>
                        <Divider/>
                        <Item key={MENU_DEL_ROW}>{locale['table_delete'] /*删除行*/}</Item>
                        <Divider/>
                    </>}
                    {showWidthAndHeightConfig &&
                        <SubMenu key="sub" title={locale['set_width_height'] /*宽高设置*/} popupClassName='context-sub-menu' popupOffset={[11]}>
                            {!disabled.has(MENU_AUTO_WRAP) && <Item key={MENU_AUTO_WRAP}>
                                <Checkbox 
                                    checked={getAutoWrap(store, id)}
                                    onChange={this.handleWrapChange}
                                >
                                    {locale['auto_wrap'] /*自动换行*/}
                                </Checkbox>
                            </Item> }
                            { columnWidthConfig && <Item key={MENU_SAVE_COL_WIDTH}>{locale['save_width'] /*保存列宽*/}</Item> }
                            { columnWidthConfig && <Item key={MENU_RESET}>{locale['table0031'] /*重置*/}</Item> }
                        </SubMenu>
                    }
                    {!cancelCustomRightMenu && <Item key={MENU_COL_SETTING}>{locale['menu_column_setting'] /*列表设置*/}</Item>}
                    {extendRightMenuPlacement === 'bottom' && <div onClick={this.handleMenuClick}>{extendRightMenu?.({
                        rowIndex: rowInfo.dataIndex, 
                        attrcode: colInfo?.col?.key, 
                        column: colInfo?.col,
                        record: rowInfo?.row,
                    }) || ''}</div>}
                </Menu>
            </div>, div);

            this.setState({ addDownNum: 0, addUpNum: 0 });
            onVisibleChange?.(true);

            this.setPosition(event, div);
        }

        handleContextMenuClose = () => {
            if (this.contextMenuContainer) {
                let { contextMenuConfig = {} } = this.props,
                    { onVisibleChange } = contextMenuConfig;

                unmountComponentAtNode(this.contextMenuContainer);
                document.body.removeChild(this.contextMenuContainer);
                this.contextMenuContainer = null;

                this.setState({ addDownNum: 0, addUpNum: 0 });
                onVisibleChange?.(false);
            }
        }

        handleOutsideClick = event => {
            if (!this.contextMenuContainer?.contains(event.target)) {
                this.handleContextMenuClose();
            }
        }

        // 抄的以前代码
        setPosition = (event, container) => {
            // clientX/Y 获取到的是触发点相对于浏览器可视区域左上角距离
            const clickX = event.clientX;
            const clickY = event.clientY;
            // window.innerWidth/innerHeight 获取的是当前浏览器窗口的视口宽度/高度
            const screenW = window.innerWidth;
            const screenH = window.innerHeight;
            // 获取自定义菜单的宽度/高度
            const rootW = container.offsetWidth;
            const rootH = container.offsetHeight;
        
            // right为true，说明鼠标点击的位置到浏览器的右边界的宽度可以放下菜单。否则，菜单放到左边。
            // bottom为true，说明鼠标点击位置到浏览器的下边界的高度可以放下菜单。否则，菜单放到上边。
            const right = screenW - clickX > rootW;
            const left = !right;
            const bottom = screenH - clickY > rootH;
            const top = !bottom;
            if (right) {
                container.style.left = `${clickX}px`;
            }
            if (left) container.style.left = `${clickX - rootW}px`;
            if (bottom) container.style.top = `${clickY}px`;
            if (top) container.style.top = `${clickY - rootH}px`;
            if (screenW - clickX < 110 + 32) {
                container.classList.add('nearRight');
            }
        }

        handleMenuClick = ({ key }) => {
            const { store, rows, contextMenuConfig = {}, id } = this.props;
            const { rowInfo, colInfo, addUpNum, addDownNum } = this.state;

            let { onClick, rightMenuClick } = contextMenuConfig;

            onClick?.(key);

            this.handleContextMenuClose();

            let rowKey = rowInfo.row?.key;
            let colKey = colInfo.col?.key;

            // 判断有没有框选范围
            let selectedCell = store.getSelectedCell();

            switch(key){
                // 复制
                case MENU_COPY:
                    if(!rowKey || !colKey) return;

                    let content = '';

                    // 判断有没有框选范围, 且右键位置在框选范围内
                    if(selectedCell?.size && selectedCell.get(rowKey)?.has(colKey)){
                        // selectedCell是map 需要转数组
                        content = [...selectedCell].map(([selectedRowKey, columns]) => 
                            // columns是set 需要转数组
                            [...columns].map(selectedColKey => 
                                store.getCellValue(selectedRowKey, selectedColKey)._display_ || '',
                            ).join('\t'),
                        ).join('\r');

                    } else {
                        // 不在框选范围内，复制单元格内容，且仅选中此单元格
                        content = store.getCellValue(rowKey, colKey)._display_ || '';
                    }

                    store.copy(content);
                    break;
                // 复制行
                case MENU_COPY_ROW:
                    if(!rowKey) return;

                    let rowDisplay = '';

                    // 判断有没有框选范围, 且右键位置在框选范围内 没有列key 那么复制框选的行，有列，要判断是不是在框选范围内
                    if(selectedCell?.size && (colKey && selectedCell.get(rowKey)?.has(colKey) || !colKey && selectedCell.get(rowKey))){
                        rowDisplay = [...selectedCell].map(([selectedRowKey]) => 
                            // colInfo.columns是array 不需要转数组
                            colInfo.columns.map(col => store.getCellValue(selectedRowKey, col.key)?._display_ || '').join('\t'),
                        ).join('\r');

                    } else {
                        rowDisplay = colInfo.columns.map(col => store.getCellValue(rowKey, col.key)?._display_ || '').join('\t');
                    }

                    store.copy(rowDisplay);
                    break;
                // 复制列
                case MENU_COPY_COL:
                    if(!colKey) return;

                    let colDisplay = '';

                    // selectedCell是map 需要转数组 拿到第一行的列数据即可
                    let columns = selectedCell?.size && [...selectedCell][0]?.[1] ? [...selectedCell][0][1] : new Set();
                    
                    // 判断有没有框选范围, 且右键位置在框选范围内 没有行key 那么复制框选的列，有行key, 要判断是不是在框选范围内
                    if(selectedCell?.size && (rowKey && selectedCell.get(rowKey)?.has(colKey) || !rowKey && columns.has(colKey))){

                        // columns是set 也需要转数组
                        colDisplay = rows.map(row => 
                            [...columns].map(selectedColKey => 
                                store.getCellValue(row.key, selectedColKey)?._display_ || '').join('\t'),
                        ).join('\r');

                    } else {
                        colDisplay = rows.map(row => store.getCellValue(row.key, colKey)?._display_ || '').join('\r');
                    }
                    store.copy(colDisplay);
                    break;
                // 向上增行
                case MENU_ADD_ROW_UP:
                    if(addUpNum <= 0) return;
                    let upRows = [...new Array(addUpNum)].map(() => ({ values: {} }));
                    store.addRow(rowInfo.rowIndex, upRows);
                    typeof rightMenuClick === 'function' && rightMenuClick('insert_up', addUpNum, rowInfo.rowIndex, { tableId:id });
                    break;
                // 向下增行
                case MENU_ADD_ROW_DOWN:
                    if(addDownNum <= 0) return;
                    let downRows = [...new Array(addDownNum)].map(() => ({ values: {} }));
                    store.addRow(rowInfo.rowIndex + 1, downRows);
                    typeof rightMenuClick === 'function' && rightMenuClick('insert_down', addDownNum, rowInfo.rowIndex + 1, { tableId:id });
                    break;
                // 删行
                case MENU_DEL_ROW:
                    if(!rowKey) return;
                    let checkedKeys = store.getCheckedKeys();
                    
                    checkedKeys.delete(rowKey);
                    store.setCheckedKeys(checkedKeys);
                    store.deleteRow(rowKey);
                    typeof rightMenuClick === 'function' && rightMenuClick('delete', 1, rowInfo.rowIndex, { tableId:id }); //TODO 暴露给业务的index是不是要转成dataIndex
                    break;
                // 自动换行
                case MENU_AUTO_WRAP:
                    this.handleWrapChange(!getAutoWrap(store, id));
                    break;
                // 保存列宽
                case MENU_SAVE_COL_WIDTH:
                    this.handleSaveWidthSelect();
                    break;
                // 重置列宽
                case MENU_RESET: 
                    this.handleResetWidthSelect();
                    break;
                // 列设置
                case MENU_COL_SETTING:
                    this.showColSettingSide();
                    break;
            }
        }

        /**
         * 重置列宽
         *  - 需要更新界面
         */
        handleResetWidthSelect = () => {
            const { store, id, locale } = this.props;

            resetWidths(store, id).then(res => {
                if(res.success){
                    return getRawColumns(store, id);
                }
            }).then(res => {
                // 获取模板并设置列宽
                res.data[0].areas[id].items
                    .forEach(col => {
                        store.setColumnProps(
                            col.code, 
                            { width: Number(col.width) || store.getInstance()._getDefaultWidth(col.itemtype) }, 
                            { shouldUpdate: false },
                        );
                    });

                // 清除localStorage里的列宽信息
                setLocalStorageColumnsWidth(store, id, null);
                store.resetColumnsWidth();

                store.forceUpdate();
                
                showSuccessToast(`${locale['colwidth_reset_success'] /*列宽重置成功*/}`);
            });
            this.setState({ showColSetting: false });
        }

        /**
         * 保存列宽
         *  - 不需要更新界面
         */
        handleSaveWidthSelect = () => {
            let { store, id, locale } = this.props,
                widths = store.getColumnsWidth();

            if(!widths || !Object.keys(widths).length){ //没有改变
                showSuccessToast(`${locale['colwidth_set_success'] /*列宽保存成功*/}`);
                return;
            }

            getRawColumns(store, id).then(res => {
                if(res.success){
                    let columns = res.data[1][id].items.map(col => ({ ...col, key: col.attrcode }));
                    // 保存列宽
                    columns = columns.map(col => {
                        if(widths[col.key]){
                            col.width = String(widths[col.key]);
                        }
                        return col;
                    });

                    return setColumns(store, id, columns);
                }
            }).then(res => {       
                if(res.success){ 
                    // 保存列宽到localStorage
                    let columns = store.getColumns();
                    let columnsMap = {};
                    columns.forEach(col => columnsMap[col.key] = col);
                    let savedWidths = {};
                    Object.keys(widths).filter(colKey => !isValidType(columnsMap[colKey]?.itemtype)).forEach(colKey => savedWidths[colKey] = widths[colKey]);
                    if(!savedWidths || !Object.keys(savedWidths).length) return;

                    setLocalStorageColumnsWidth(store, id, savedWidths);
                    
                    showSuccessToast(`${locale['colwidth_set_success'] /*列宽保存成功*/}`);
                }
            });
        }

        handleWrapChange = value => {
            const { store, id, contextMenuConfig } = this.props;
            setAutoWrap(store, id, value);
            contextMenuConfig?.onClick?.(MENU_AUTO_WRAP);
        }

        showColSettingSide = () => {
            this.setState({ showColSetting: true });
        }

        hideColSettingSide = () => {
            this.setState({ showColSetting: false });
        }
    };
}

useContextMenu.displayName = 'useContextMenu';
useContextMenu.dependence = [];

export default useContextMenu;

export function setAutoWrap(store, id, flag){
    let savedKey = getLocalStorageKey(store, id, 'foldFlag');
    let savedValue = getGlobalStorage('localStorage', 'fold_flag');
    if (savedValue) {
        savedValue = JSON.parse(savedValue);
    } else {
        savedValue = {};
    }
    savedValue = { 
        ...savedValue,
        [savedKey]: flag, 
    };

    setGlobalStorage('localStorage', 'fold_flag', JSON.stringify(savedValue));
}

export function getAutoWrap(store, id){
    let savedKey = getLocalStorageKey(store, id, 'foldFlag');
    let savedValue = getGlobalStorage('localStorage', 'fold_flag') || {};
    if(typeof savedValue === 'string'){
        savedValue = JSON.parse(savedValue);
    }
    return !!savedValue?.[savedKey];
}